// ** Type Imports
import type { OwnerStateThemeType } from '.';

const FormControl = () => {
  return {
    MuiFormControl: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          marginBottom: `${theme.spacing(8)}`,
          '&:last-child': {
            marginBottom: 0,
          },
          '& > .MuiFormControl-root': {
            marginBottom: 0,
          },
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          lineHeight: '1.3',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          lineHeight: '1.3',
          marginLeft: '4px',
          marginRight: '4px',
        },
      },
    },
  };
};

export default FormControl;
